var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 76,
    r: 76,
    fill: "#91E352"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76 152C117.974 152 152 117.974 152 76.0002C152 72.6424 151.782 69.3355 151.36 66.0928L123.296 45.6653C104.16 63.7139 65.4318 99.8112 63.6052 99.8112C61.7786 99.8112 38.7068 88.5036 27.3992 82.8498L39.7908 142.837C50.5555 148.681 62.8901 152 76 152Z",
    fill: "#58AE16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.726 45.6932C127.674 49.8939 127.469 56.4996 123.268 60.4473L70.9657 109.599C65.8296 114.426 57.7887 114.301 52.805 109.317L29.1516 85.6638C25.0754 81.5876 25.0754 74.9788 29.1516 70.9026C33.2278 66.8264 39.8367 66.8264 43.9129 70.9026L62.2 89.1897L108.972 45.235C113.173 41.2873 119.779 41.4924 123.726 45.6932Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.3d15ecd81b3bd742c15d164f6f212a56.svg";
export { ForwardRef as ReactComponent };